import React from 'react';

function AdditionsList(props) {
  const formatValue = (val, isPercent) => {
    if (isPercent === true) {
      return `${val} درصد`;
    }

    return `${val} تومان`;
  };

  return (
    <table>
      <caption>لیست اضافات فاکتور</caption>
      <thead>
        <tr>
          <th>ردیف</th>
          <th>عنوان</th>
          <th>مقدار</th>
        </tr>
      </thead>
      <tbody>
        {props.data &&
          props.data.length &&
          props.data.map((additionItem, ix) => (
            <tr key={additionItem.id}>
              <td>{ix + 1}</td>
              <td>{additionItem.title}</td>
              <td>{formatValue(additionItem.value, additionItem.isPercent)}</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}

export default AdditionsList;
